export const fsMatrix = (matrix: any[][]): any[][] => {
    return matrix[0].map((_, index) => [...matrix].map((row) => row[index]));
};
